import { html } from "lit";

export const twitterIcon = (theme: string) => html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    class="${theme === "purple" ? "twf-fill-white" : "twf-fill-[#282828]"}"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2548 4.87911C14.2645 5.01911 14.2645 5.15911 14.2645 5.30041C14.2645 9.60557 10.9871 14.5707 4.99419 14.5707V14.5681C3.22387 14.5707 1.49032 14.0636 0 13.1075C0.257419 13.1385 0.516129 13.154 0.775484 13.1546C2.24258 13.1559 3.66774 12.6636 4.82194 11.7572C3.42774 11.7307 2.20516 10.8217 1.77806 9.4946C2.26645 9.58879 2.76968 9.56944 3.24903 9.43847C1.72903 9.13137 0.635484 7.79589 0.635484 6.24492C0.635484 6.23073 0.635484 6.21718 0.635484 6.20363C1.08839 6.45589 1.59548 6.59589 2.11419 6.61137C0.682581 5.6546 0.24129 3.75008 1.10581 2.26105C2.76 4.29653 5.20064 5.53395 7.82064 5.66492C7.55806 4.53331 7.91677 3.3475 8.76323 2.55202C10.0755 1.31847 12.1394 1.3817 13.3729 2.69331C14.1026 2.54944 14.8019 2.2817 15.4419 1.90234C15.1987 2.65653 14.6897 3.29718 14.0097 3.70428C14.6555 3.62815 15.2865 3.45524 15.8806 3.19137C15.4432 3.84686 14.8923 4.41782 14.2548 4.87911Z"
    />
  </svg>
`;
